<template>
  <div class="flex justify-between items-center mb-5">
    <div class="flex items-center flex-grow group">
      <aha-icon
        name="aha-fire"
        class="text-transparent"
        width="16"
        height="16"
        viewBox="0 0 16 16"
      />
      <span class="px-2 font-normal">{{ $i18nPresenter.t('Streak answer') }}</span>
      <b-button
        v-tooltip="streakTooltip"
        class="text-secondary-40 cursor-pointer hidden group-hover:inline-block"
      >
        <i class="fas fa-question-circle" />
      </b-button>
    </div>
    <toggle-button
      v-model="presentation.isEnableStreakDetection"
      :disabled="isDisableEditPresentation"
      :width="35"
      :height="20"
      class="mb-0"
      :color="{
        checked: '#6A1EBB',
        unchecked: '#D3D7E1'
      }"
      @change="onChangeStreakSetting()"
    />
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import utils from '@/util'
import eventCategories from '@/constant/eventCategories'

export default {
  props: {
    isDisableEditPresentation: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState({
      presentation: (state) => state.presentation,
    }),
    streakTooltip() {
      return {
        content: this.$i18nPresenter.t('Show the streak answer in the quiz'),
      }
    },
  },
  methods: {
    ...mapActions(['updatePresentation']),
    onChangeStreakSetting() {
      const isStreakEnabled = this.presentation.isEnableStreakDetection
      const payload = {
        isEnableStreakDetection: isStreakEnabled,
      }

      if (!isStreakEnabled) {
        payload.isEnableStreakBonus = false
        this.updatePresentation({
          isEnableStreakBonus: false,
        })
      }

      this.$emit('updatePresentation', payload)

      const action = isStreakEnabled ? 'Enable' : 'Disable'
      utils.mixpanelTracking(
        eventCategories.PRESENTATION_EDITOR,
        `Settings menu > Quiz settings > Enable streak > ${action}`,
      )
    },
  },
}
</script>
